import React, { useState, useEffect } from 'reactn';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { Route } from 'react-router-dom';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
// import history from '../History/History';

const axios = require('axios').default;

export const getAccessToken = () => Cookies.get('access_token');
export const getRefreshToken = () => Cookies.get('refresh_token');
export const isAuthenticated = () => !!getAccessToken();

// const redirectToHome = () => {
//     window.location.href = '/';
// };
const redirectToLogin = () => {
    window.location.href = '/';
};
export const redirectToSecure = () => {
    window.location.href = '/secure';
};
const redirectToLoading = () => {
    window.location.href = '/secure/loading';
};

export const Login = (tokens) => {
    const expires = (tokens.expires_in || 60 * 60) * 1000;
    const inOneHour = new Date(new Date().getTime() + expires);
    Cookies.set('access_token', tokens.access_token, { expires: inOneHour });
    Cookies.set('refresh_token', tokens.refresh_token);
    redirectToLoading();
};

export const Logout = () => {
    // eslint-disable-next-line
    console.log('Logging out...');
    Cookies.remove('access_token');
    Cookies.remove('refresh_token');
    redirectToLogin();
};

export function Api() {
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        // responseType: 'json',
        headers: {
            common: {
                Authorization: `Bearer ${getAccessToken()}`
            }
        }
    });
    instance.interceptors.request.use((request) => {
        request.headers.Authorization = `Bearer ${getAccessToken()}`;
        return request;
    });

    createAuthRefreshInterceptor(instance, (failedRequest) => {
        instance
            .post('/merchant-portal/public/login/refresh', {
                refresh_token: getRefreshToken()
            })
            .then((tokenRefreshResponse) => {
                Login({
                    access_token: tokenRefreshResponse.data.access_token.id,
                    refresh_token: tokenRefreshResponse.data.refresh_token.id
                });
                // eslint-disable-next-line
                failedRequest.headers.Authentication = `Bearer ${tokenRefreshResponse.data.access_token.id}`;
                return Promise.resolve();
            })
            .catch(() => {
                Logout();
            });
    });
    return instance;
}

const refreshTokens = () => {
    Api
        .post(`${process.env.REACT_APP_API_BASE_URL}/merchant-portal/public/login/refresh`, {
            refresh_token: getRefreshToken()
        })
        .then((tokenRefreshResponse) => {
            return {
                access_token: tokenRefreshResponse.data.access_token.id,
                refresh_token: tokenRefreshResponse.data.refresh_token.id
            };
        })
        .catch(() => {
            console.log('catch');
        });
};

export const authenticate = async () => {
    if (getRefreshToken()) {
        try {
            const tokens = await refreshTokens();
            Login(tokens);

            return true;
        } catch (error) {
            redirectToLogin();
            return false;
        }
    }
    redirectToLogin();
    return false;
};

export function AuthenticatedRoute({
    component,
    exact,
    path,
    basename
}) {
    return (
        <Route
            exact={exact}
            path={path}
            basename={basename}
            render={(routeProps) => {
                return (
                isAuthenticated() ? (
                    component(routeProps)
                ) : (
                    <AuthenticateBeforeRender render={() => component}/>
                )
                );
            }}
        />
    );
}

AuthenticatedRoute.propTypes = {
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string.isRequired,
    basename: PropTypes.string
};
AuthenticatedRoute.defaultProps = {
    basename: '',
    exact: false
};

/**
 *
 * @param props
 * @returns {null}
 * @constructor
 */
export function AuthenticateBeforeRender(props) {
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        authenticate()
            .then((response) => {
                setAuthenticated(response);
            });
    }, []);
    return (
        authenticated ? props.render() : null
    );
}